/* ==========================================================================
   Ryse - Theoric: NUCLEO do carrinho

   ===================  O PROBLEMA QUE ESTE ARQUIVO RESOLVE  ==================
   Romulo relatou "piscadas". Instrumentei e medi - duas vezes, dois sintomas,
   uma so doenca.

   AO APLICAR O CUPOM (antes)
     6 blocos somem juntos e voltam espalhados; o seletor some DUAS vezes.
     total: 14 sumicos/voltas | 10 requisicoes (o /cart.js chamado 9x)

   AO MUDAR A QUANTIDADE (antes)
     /cart/change ................ -> renderContents (demolicao 1)
     /cart?section_id=cart-theoric -> renderContents (demolicao 2)
     total: 14 sumicos/voltas, DOIS ciclos completos.
     E o alerta de estoque PISCAVA - porque o redesenho que o exibe e o mesmo
     que o mata, antes de o cliente conseguir ler. A mensagem era legitima;
     quem a jogava fora era a interface.

   A CAUSA (a mesma nos dois casos):
   cart-theoric.renderContents() troca o innerHTML da gaveta INTEIRA. Tudo o que
   injetamos morre junto. E os modulos, cada um com o SEU observer e o SEU
   fetch, reconstruiam no proprio tempo, re-animando a entrada a cada volta.
   A piscada nao era falta de motion. Era o DOM sendo demolido e reerguido.

   A SOLUCAO (este arquivo):
   1. UMA fonte de verdade do carrinho, com UM fetch. Os modulos se inscrevem.
   2. Toda acao do carrinho - cupom, quantidade, remocao - passa por AQUI e NAO
      pede `sections`. Assim renderContents nunca e chamado: nada e destruido,
      os valores sao pintados no lugar, e nao ha o que piscar.
   3. Ha UMA excecao, e ela e legitima: quando o carrinho FICA VAZIO, a gaveta
      inteira vira outra coisa (o estado vazio do tema). Ali redesenhar e o
      certo - tudo mudou mesmo. Redesenho nao e proibido; redesenho SEM MOTIVO
      e que era o bug.

   Medido DEPOIS: 0 sumicos, 1 requisicao por acao.

   >>> REGRA PARA QUEM VIER DEPOIS <<<
   Precisa mexer no carrinho? Use TheoricCart.definirCupom / mudarLinha.
   Precisa reagir a uma mudanca? Use TheoricCart.ao(fn) e PINTE o que ja existe.
   Nao crie outro MutationObserver, nao chame outro /cart.js, e nao mande
   `sections` num POST a menos que a gaveta inteira precise mesmo virar outra.

   Carregado ANTES dos outros por sections/cart-theoric.liquid.
   ========================================================================== */
(function () {
  'use strict';

  /* O tema pode reinjetar a tag <script> ao redesenhar a secao. Se este arquivo
     rodasse duas vezes, haveria dois observers e dois estados brigando - e o
     bug voltaria pela porta dos fundos. */
  if (window.TheoricCart) return;

  var ouvintes = [];
  var estado = null;
  var buscando = null;   // a promessa em voo - serve de "trava" contra duplicatas
  var agendado = null;

  function gaveta() { return document.querySelector('cart-theoric'); }

  /* ==========================================================================
     >>> ARMADILHA MEDIDA: OS DOIS ENDPOINTS MENTEM DIFERENTE <<<

     A MESMA informacao vem com DOIS formatos, dependendo de quem responde:

       GET  /cart.js
         cart_level_discount_applications: [
           { type: "discount_code", title: "BEMVINDO10", value: "10.0", ... }
         ]

       POST /cart/update.js
         cart_level_discount_applications: [
           { amount: 4980, discount_application: { type, title, value, ... } }
         ]
                                            ^^^^^^^^^^^^^^^^^^^^ aninhado!

     Um filtro por `d.type === 'discount_code'` funciona no primeiro e devolve
     LISTA VAZIA no segundo - sem erro, sem aviso. O sintoma: o cupom era
     aplicado, o total caia, o preco do card era riscado... e o chip do cupom
     simplesmente nao nascia. O bug morava no formato, nao na logica.

     normalizar() achata os dois. Todo modulo le daqui. Se um dia surgir um
     terceiro formato, conserta-se AQUI - num lugar so.

     >>> SEGUNDA ARMADILHA: CUPOM DE PRODUTO/COLECAO NAO E "DO CARRINHO" <<<
     cart_level_discount_applications so cobre cupons de PEDIDO INTEIRO. Um
     cupom que desconta produtos/colecoes especificas nunca aparece ali - ele
     so aparece em items[].discounts (o mesmo campo que ja alimenta o selo do
     card, ver montarPreco em theoric-cart-item.js). Medido: o total cai, o
     card mostra o desconto... e validar() em theoric-cart-cupom.js dizia
     "cupom invalido" porque so olhava o nivel do carrinho. Por isso
     normalizar() tambem varre as linhas - so preenchendo o que o nivel do
     carrinho ainda nao cobriu, senao um cupom de pedido inteiro seria contado
     2x (uma vez no total, outra na soma das linhas que ele mesmo alocou).
     ========================================================================== */
  function normalizar(carrinho) {
    var porTitulo = {};
    var cobertosPeloCarrinho = {};

    ((carrinho && carrinho.cart_level_discount_applications) || []).forEach(function (d) {
      var base = d.discount_application || d;  // formato do /cart/update.js
      if (base.type !== 'discount_code') return;

      var chave = String(base.title || '').trim().toUpperCase();
      if (!chave) return;

      cobertosPeloCarrinho[chave] = true;
      porTitulo[chave] = {
        type: base.type,
        title: base.title,
        value: base.value,
        value_type: base.value_type,
        total_allocated_amount: (d.amount != null ? d.amount : base.total_allocated_amount) || 0
      };
    });

    ((carrinho && carrinho.items) || []).forEach(function (linha) {
      (linha.discounts || []).forEach(function (d) {
        var chave = String(d.title || '').trim().toUpperCase();
        if (!chave || cobertosPeloCarrinho[chave]) return;

        if (!porTitulo[chave]) {
          porTitulo[chave] = {
            type: 'discount_code',
            title: d.title,
            value: undefined,
            value_type: undefined,
            total_allocated_amount: 0
          };
        }
        porTitulo[chave].total_allocated_amount += Number(d.amount) || 0;
      });
    });

    return Object.keys(porTitulo).map(function (k) { return porTitulo[k]; });
  }

  /* --------------------------------------------------------------------------
     UM fetch, nao nove.
     Se ja ha uma busca em voo, quem chegar depois pega carona nela.
     -------------------------------------------------------------------------- */
  function buscar(forcar) {
    if (buscando) return buscando;
    if (estado && !forcar) return Promise.resolve(estado);

    buscando = fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        estado = c;
        return c;
      })
      .catch(function (e) {
        console.warn('[theoric-cart-core] falha ao ler o carrinho.', e);
        return estado;
      })
      .finally(function () {
        buscando = null;
      });

    return buscando;
  }

  function avisar(carrinho) {
    ouvintes.forEach(function (fn) {
      try {
        fn(carrinho);
      } catch (e) {
        // um modulo quebrado nao pode derrubar os outros
        console.error('[theoric-cart-core] um ouvinte falhou.', e);
      }
    });
  }

  function sincronizar(forcar) {
    clearTimeout(agendado);
    agendado = setTimeout(function () {
      buscar(forcar !== false).then(function (c) {
        if (c) avisar(c);
      });
    }, 40);
  }

  /* --------------------------------------------------------------------------
     A BOLINHA do carrinho no cabecalho.

     Ela e uma secao do tema, e antes se atualizava sozinha - de carona no
     redesenho da gaveta. Como agora nao redesenhamos, ela virou nossa: e o
     preco de nao demolir, passar a cuidar do que o tema cuidava de graca.

     >>> ARMADILHA (bug real, achado ao esvaziar o carrinho) <<<
     A primeira versao procurava #cart-icon-bubble no HTML devolvido pela secao.
     Nao existe. A Section Rendering API embrulha tudo em
     #shopify-section-<id> - e o #cart-icon-bubble da PAGINA e o <a> de fora,
     nao o conteudo. O getElementById voltava null, a funcao saia em silencio, e
     o contador ficava CONGELADO. Sem erro, sem aviso: so um numero errado.
     Licao: quando um seletor volta vazio, nao saia calado - o silencio some, o
     bug fica.
     -------------------------------------------------------------------------- */
  function atualizarBolinha() {
    var alvo = document.getElementById('cart-icon-bubble');
    if (!alvo) return;

    fetch('/?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var novo = doc.getElementById('shopify-section-cart-icon-bubble') ||
                   doc.querySelector('.shopify-section');

        if (!novo) {
          console.warn('[theoric-cart-core] a secao cart-icon-bubble veio num ' +
                       'formato inesperado - o contador nao foi atualizado.');
          return;
        }

        alvo.innerHTML = novo.innerHTML;
      })
      .catch(function () { /* bolinha errada nao justifica quebrar a gaveta */ });
  }

  /* ==========================================================================
     CUPOM - aplicado SEM redesenhar a gaveta

     >>> CUPOM INVALIDO NAO DA ERRO NA SHOPIFY <<<
     O /cart/update.js devolve status 200 e IGNORA o codigo, em silencio. Por
     isso quem chama precisa conferir se o codigo entrou de fato (ver validar()
     em theoric-cart-cupom.js). Nao confie no status HTTP.
     ========================================================================== */
  function definirCupom(codigo) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codigo }) // sem `sections`: nada de redesenho
    })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        estado = c;
        avisar(c);   // pinta no lugar
        return c;
      });
  }

  /* ==========================================================================
     QUANTIDADE E REMOCAO - tambem sem redesenhar

     >>> POR QUE `line` (a POSICAO) E NAO `id` (a chave da linha) <<<
     A chave item.key tem um hash que MUDA conforme o endpoint que responde
     (medido: /cart.js e /cart/update.js devolvem hashes diferentes para a mesma
     linha). Endereca-la por ela e apostar num identificador instavel. A
     posicao, 1-based, e o que o proprio tema usa (data-index) e nao depende de
     hash nenhum.
     A contrapartida: ao remover uma linha, as posicoes seguintes andam. Por
     isso quem remove tira o card do DOM ANTES de repintar - assim a ordem dos
     cards e a ordem do array do carrinho continuam sendo a mesma coisa.

     >>> O 422 E UMA RESPOSTA, NAO UMA FALHA <<<
     Se a pessoa pedir mais do que se pode levar, a Shopify devolve 422 - e SEM
     o carrinho no corpo. Entao aqui: nao se pinta com esse corpo, busca-se o
     estado real, e devolve-se o erro para quem chamou mostrar com calma, no
     lugar certo, sem piscar.
     ========================================================================== */
  function mudarLinha(linha, quantidade) {
    var anterior = estado;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: linha, quantity: quantidade })
    })
      .then(function (r) {
        return r.json().then(function (corpo) {
          return { ok: r.ok, corpo: corpo };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          return buscar(true).then(function (c) {
            if (c) avisar(c);
            return {
              ok: false,
              erro: res.corpo.description || res.corpo.message ||
                    'Não foi possível alterar a quantidade.',
              carrinho: c
            };
          });
        }

        estado = res.corpo;
        // Descontos BXGY podem dividir uma variante em linhas paga e grátis.
        // Pintar apenas os cards existentes deixaria uma dessas linhas oculta.
        if (anterior && estruturaDasLinhas(anterior) !== estruturaDasLinhas(res.corpo)) {
          return redesenharGaveta(res.corpo).then(function () {
            return { ok: true, carrinho: res.corpo, redesenhado: true };
          });
        }
        avisar(res.corpo);
        atualizarBolinha();
        return { ok: true, carrinho: res.corpo };
      });
  }

  function estruturaDasLinhas(carrinho) {
    return JSON.stringify((carrinho.items || []).map(function (item) {
      var props = item.properties || {};
      return [String(item.variant_id), Object.keys(props).sort().map(function (chave) {
        return [chave, props[chave]];
      })];
    }));
  }

  /* --------------------------------------------------------------------------
     Redesenho quando o carrinho fica vazio ou muda a estrutura das linhas.
     A gaveta deixa de ser uma lista e passa a ser um convite ("Sua bolsa esta
     vazia"). Nao ha o que pintar - tudo virou outra coisa. Aqui redesenhar e o
     certo. Um BXGY também pode criar ou fundir linhas pagas e gratuitas;
     nesse caso os cards precisam acompanhar a lista devolvida pelo servidor.
     -------------------------------------------------------------------------- */
  function redesenharGaveta(carrinho) {
    var g = gaveta();
    if (!g) return Promise.resolve();

    return fetch('/?section_id=cart-theoric')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nova = doc.querySelector('cart-theoric');
        if (nova) g.innerHTML = nova.innerHTML;
        estado = carrinho && Array.isArray(carrinho.items) ? carrinho : null;
        atualizarBolinha();
        if (estado) avisar(estado);
        else sincronizar(true); // os modulos limpam o estado vazio
      })
      .catch(function (e) {
        console.warn('[theoric-cart-core] falha ao reconciliar as linhas da gaveta.', e);
        sincronizar(true);
        throw e;
      });
  }

  /* ========================================================================== */
  window.TheoricCart = {
    ao: function (fn) {
      ouvintes.push(fn);
      if (estado) {
        try { fn(estado); } catch (e) { console.error(e); }
      }
      return fn;
    },

    estado: function () { return estado; },
    sincronizar: sincronizar,
    definirCupom: definirCupom,
    mudarLinha: mudarLinha,
    redesenharGaveta: redesenharGaveta,
    atualizarBolinha: atualizarBolinha,

    moeda: function (centavos) {
      return (centavos / 100).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      });
    },

    /* Use SEMPRE isto. Nunca leia cart_level_discount_applications direto:
       o formato muda conforme o endpoint (ver normalizar()). */
    cuponsAtivos: normalizar
  };

  /* --------------------------------------------------------------------------
     UM unico observer para a gaveta inteira.
     Rede de seguranca: se o TEMA redesenhar por conta propria (algum caminho
     que ainda nao interceptamos), os modulos remontam - UMA vez, coordenados.
     -------------------------------------------------------------------------- */
  function vigiar() {
    var alvo = gaveta();
    if (!alvo) return;

    var obs = new MutationObserver(function () {
      var rodape = document.querySelector('.theoric__footer-inner');
      if (rodape && !rodape.querySelector('[data-theoric-pay]')) {
        sincronizar(true);
      }
    });

    obs.observe(alvo, { childList: true, subtree: true });
  }

  function iniciar() {
    if (!gaveta()) return;
    vigiar();
    sincronizar(true);

    if (typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        sincronizar(true);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
